import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { CustomerResource } from "@exonn/js-sdk";
import type { ModuleOptions } from "src/system/module.types.ts";
import { CustomerOrders } from "src/admin/modules/customer/forms/customer/tabs/orders/CustomerOrders.tsx";

export const module: ModuleOptions<CustomerResource> = {
  resource: ResourceEnum.Customer,
  bigIcon: <i className="icon-20-customers" />,
  smallIcon: <i className="icon-15-customers" />,
  tabs: {
    edit: {
      titleProp: "number",
    },
  },
  formTabs: {
    general: {
      title: (t) => t("formTabs.general.title"),
    },
    // Поздравления Anlasskampagnen и прочие сообщения клиенту (DEC-023).
    communication: {
      title: (t) => t("formTabs.communication.title"),
    },
    orders: {
      title: (t) => t("formTabs.orders.title"),
      routeObject: {
        Component: CustomerOrders,
      },
      isHidden: ({ data }) => !data?.id,
    },
  },
};
